export const tableOption = {
    'border': true,
    // 'index': true,
    // 'indexLabel': '序号',
    'stripe': true,
    'menuAlign': 'center',
    'menuWidth': 150,
    'align': 'center',
    'refreshBtn': false,
    'columnBtn': false,
    'searchSize': 'mini',
    'searchBtn': false,
    'addBtn': false,
    'editBtn': false,
    'delBtn': false,
    menu:false,
    stripe:false,
    
    "column": [
      {
        label: '序号',
        prop: 'id',
        solt:true
      },
      {
        label: '菜单名称',
        prop: 'name',
        
      },
      {
        label: '排序',
        prop: 'orderNum'
      },
      {
        label: '模板',
        prop: 'templateId'
      },
      {
        label: '菜单描述',
        prop: 'tips'
      }
    ]
  }
  